module.exports = __webpack_public_path__ + "static/media/unknown.4788048f.png";